<template>
  <div>
    <Card :dockedPosition="dockedPosition" :title="title">
      <template #content>
        <div class="p line-breaks" v-dompurify-html="$t('errorTile.text')"></div>
      </template>
      <template #footer>
        <div class="footer-cta footer-cta--left">
          <CustomButton
            @click="refreshPage"
            id="postbox.error-reload-button"
            class="button-refresh"
            :buttonColor="ButtonColor.PRIMARY"
          >
            {{ $t('errorTile.reloadPage') }}
          </CustomButton>
        </div>
      </template>
    </Card>
  </div>
</template>

<script lang="ts" setup>
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'

defineProps({
  title: {
    type: String
  },
  dockedPosition: {
    type: String,
    default: 'false'
  }
})

const refreshPage = () => {
  globalThis.location.reload()
}
</script>

<style scoped>
.p {
  font-family: var(--f-primary-light), serif;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 24px;
  display: inline-block;
}

.line-breaks {
  white-space: pre-wrap;
}

.button-refresh {
  @media (max-width: 426px) {
    margin-right: auto;
  }
}
</style>
